export default __webpack_public_path__ + "static/AD_5227_rgb-1cb50e77d8d25095aacef66b73993231.jpg";